import { S as SKYWALKER_TEMPLATE_ID_CAB, a as SKYWALKER_API_PATHS_CAB } from '../../../dist/cabs-7b007069.esm.js';
import { R as RecentSearchDwebRenderer } from '../../../dist/renderer-d1565cdf.esm.js';
import { S as SkywalkerRenderEntry } from '../../../dist/renderer-entry-hoc-f40a5997.esm.js';
import 'react';
import '@growth/use-analytics';
import '@growth/recent-search/Card/dweb';
import '@growth/carousal';
import '@growth/app-banners/Banners/DwebRecentSearchAppCard';
import '@growth/custom-hooks/useCardLoad';
import '@growth/object-utils';
import '@growth/pdt-push';
import '../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import 'styled-components';
import '../../../dist/style-1cded105.esm.js';
import '@growth/design-system';
import '../../../dist/extends-a2cb9f0c.esm.js';
import '../../../dist/objectWithoutPropertiesLoose-98be5ae5.esm.js';
import '@growth/custom-hooks/useApiCall';
import '@growth/validations';
import '@growth/dom-event-emitter';
import '@growth/error-card';
import '../../../dist/renderer-mapper-e4565e17.esm.js';
import '../../../fetcher/dist/growth-skywalker-fetcher.esm.js';
import '@growth/api-calls';
import '../../../dist/helpers-fe286f75.esm.js';
import '../../../dist/helper-b92d0092.esm.js';
import '@growth/recent-search/helper';
import '@growth/browser-storage';
import '@growth/loader';

/** Templates mapped with indivisual card renderer */
var skywalkerCardComponentMaps = new Map([[SKYWALKER_TEMPLATE_ID_CAB.recentSearchDweb, RecentSearchDwebRenderer]]);

var fetcherConfig = {
  apiPath: SKYWALKER_API_PATHS_CAB.desktopHome,
  apiHeaders: {
    os: 'desktop'
  }
};
var SkywalkerWeb = SkywalkerRenderEntry({
  skywalkerCardComponentMaps: skywalkerCardComponentMaps,
  fetcherConfig: fetcherConfig
});

export { SkywalkerWeb };
